var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mb-5",attrs:{"type":_vm.alert.type,"dismissible":_vm.alert.dismissible,"transition":"fade-transition"},model:{value:(_vm.alert.show),callback:function ($$v) {_vm.$set(_vm.alert, "show", $$v)},expression:"alert.show"}},[_vm._v("\n  "+_vm._s(_vm.alert.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }